export { firebaseMessagingAdapter } from '@/adapters/pushNotification/firebaseMessagingAdapter';
